<div class="dash-content fatura-detalhe-page">
  <!-- Loading Principal -->
  @if (loading()) {
  <div class="detail-skeleton">
    <p-skeleton height="4rem" class="mb-4" />
    <div class="grid-2">
      <p-skeleton height="16rem" />
      <p-skeleton height="16rem" />
    </div>
  </div>
  } @else if (documento()) {
  <!-- Cabeçalho de Navegação e Ações -->
  <header class="detail-header">
    <div class="header-left">
      <nav class="breadcrumb-trail" aria-label="Breadcrumb">
        <a routerLink="/admin/financeiro" class="breadcrumb-link">
          <i class="ri-arrow-left-line"></i> Gestão de Faturação
        </a>
        <span class="breadcrumb-separator">/</span>
      </nav>

      <div class="header-title-box">
        <div class="title-with-badge">
          <h1>{{ documento()?.documentNo }}</h1>
          <span class="status-pill" [ngClass]="getStatusClass(documento()?.estado)">
            <span class="dot"></span>
            {{ isPaga() ? 'Liquidada · Pago 100%' : documento()?.estado }}
          </span>
          @if (documento()?.rejectedDocumentNo) {
          <span class="badge-rectified">Corrige {{ documento()?.rejectedDocumentNo }}</span>
          }
        </div>
        <div class="header-meta">
          <span><i class="ri-building-line"></i> {{ cliente()?.nome || documento()?.cliente?.nome || ('Cliente #' +
            documento()?.idCliente) }}</span>
          @if (cliente()?.nif || documento()?.cliente?.nif) {
          <span><i class="ri-shield-user-line"></i> NIF: {{ cliente()?.nif || documento()?.cliente?.nif }}</span>
          }
          @if (cliente()?.numTelefone || documento()?.cliente?.numTelefone) {
          <span><i class="ri-phone-line"></i> {{ cliente()?.numTelefone || documento()?.cliente?.numTelefone }}</span>
          }
          <span><i class="ri-calendar-line"></i> Emissão: {{ documento()?.documentDate | date: 'dd/MM/yyyy' }}</span>
          <span><i class="ri-price-tag-3-line"></i> Total: <strong>{{ formatCurrency(documento()?.grossTotal)
              }}</strong></span>
          @if (documento()?.requestId) {
          <span class="font-mono text-muted"><i class="ri-hashtag"></i> Lote AGT: {{ documento()?.requestId }}</span>
          }
        </div>
      </div>
    </div>

    <!-- Ações do Cabeçalho Contextuais ao Estado -->
    <div class="header-actions">
      <!-- PDF Download (disponível em quase todos os estados) -->
      <button type="button" class="btn-action-pdf" [disabled]="downloadingPdf()" (click)="descarregarPdf()">
        <i class="ri-file-pdf-2-line" [class.ri-loader-4-line]="downloadingPdf()"
          [class.animate-spin]="downloadingPdf()"></i>
        {{ downloadingPdf() ? 'A gerar...' : 'Descarregar PDF' }}
      </button>

      <!-- SE GUARDADA -->
      @if (isGuardada()) {
      <button type="button" class="btn-action-edit" (click)="editarFatura()">
        <i class="ri-edit-line"></i> Editar
      </button>
      <button type="button" class="btn-action-submit" [disabled]="actionLoading()" (click)="submeterAgt()">
        <i class="ri-send-plane-fill" [class.ri-loader-4-line]="actionLoading()"
          [class.animate-spin]="actionLoading()"></i>
        Submeter à AGT
      </button>
      }

      <!-- SE SUBMETIDA -->
      @if (isSubmetida()) {
      <button type="button" class="btn-action-refresh" [disabled]="consultandoEstado()" (click)="consultarEstadoAgt()">
        <i class="ri-refresh-line" [class.animate-spin]="consultandoEstado()"></i>
        {{ consultandoEstado() ? 'A verificar...' : 'Consultar Estado AGT' }}
      </button>
      }

      <!-- SE REJEITADA -->
      @if (isRejeitada()) {
      <button type="button" class="btn-action-rectify" (click)="corrigirFatura()">
        <i class="ri-tools-line"></i> Corrigir e Reenviar
      </button>
      }

      <!-- SE ACEITE (E NÃO PAGA) -->
      @if (isAceite() && !isPaga()) {
      @if (!documento()?.paymentReference) {
      <button type="button" class="btn-action-multicaixa" [disabled]="actionLoading()"
        (click)="gerarReferenciaMulticaixa()">
        <i class="ri-qr-code-line"></i> Gerar Multicaixa
      </button>
      }
      <button type="button" class="btn-action-pay" (click)="abrirModalSimular()">
        <i class="ri-hand-coin-line"></i> Liquidar / Pagar
      </button>
      }
    </div>
  </header>

  <!-- ALERTA DE FATURA REJEITADA PELA AGT -->
  @if (isRejeitada()) {
  <div class="alert-banner-rejected" role="alert">
    <div class="banner-icon"><i class="ri-error-warning-fill"></i></div>
    <div class="banner-body">
      <h3>ATENÇÃO: Fatura Rejeitada pela AGT</h3>
      <p>
        O documento não foi homologado pela AGT devido a inconsistências fiscais e permanece bloqueado para emissão
        definitiva. Utilize o botão "Corrigir e Reenviar" no topo para emitir a respetiva retificação.
      </p>
      <div class="error-cause-box">
        @if (documento()?.errorList && documento()!.errorList!.length > 0) {
        <ul>
          @for (err of documento()!.errorList!; track err) {
          <li><strong>Erro AGT:</strong> {{ err }}</li>
          }
        </ul>
        } @else {
        <div><strong>Código AGT:</strong> 104 · Divergência cadastral no NIF do adquirente no sistema central da AGT.
        </div>
        }
      </div>
    </div>
  </div>
  }

  <!-- ALERTA DE FATURA SUBMETIDA EM PROCESSAMENTO -->
  @if (isSubmetida()) {
  <div class="alert-banner-processing" role="status">
    <div class="banner-icon"><i class="ri-time-line animate-spin"></i></div>
    <div class="banner-body">
      <h3>Fatura Submetida à AGT · Validação Fiscal em Curso</h3>
      <p>
        O lote fiscal <strong>#{{ documento()?.requestId || '9822' }}</strong> foi transmitido com sucesso.
        Aguardando a homologação e assinatura da chave privada no servidor central da AGT.
        Este documento não serve de comprovativo fiscal definitivo até ser Aceite.
      </p>
    </div>
  </div>
  }

  <!-- Abas de Navegação do Detalhe -->
  <div class="detail-tabs-bar">
    <button type="button" class="tab-btn" [class.active]="activeTab() === 'fatura'" (click)="activeTab.set('fatura')">
      <i class="ri-file-text-line"></i> Fatura & Linhas
    </button>
    <button type="button" class="tab-btn" [class.active]="activeTab() === 'pagamento'"
      (click)="activeTab.set('pagamento')">
      <i class="ri-wallet-3-line"></i> Pagamento & Recibos
      @if (recibos().length > 0) {
      <span class="tab-badge">{{ recibos().length }}</span>
      }
    </button>
    <button type="button" class="tab-btn" [class.active]="activeTab() === 'auditoria'"
      (click)="activeTab.set('auditoria')">
      <i class="ri-shield-keyhole-line"></i> Trilho de Auditoria Fiscal AGT
    </button>
  </div>

  <!-- CONTEÚDO DA ABA 1: FATURA & LINHAS -->
  @if (activeTab() === 'fatura') {
  <div class="tab-content-grid">
    <!-- Coluna Esquerda: Dados Gerais e Linhas -->
    <div class="content-main">
      <!-- Card de Partes (Emissor e Adquirente) -->
      <section class="section-card entities-section-card" aria-labelledby="heading-entities">
        <header class="section-card-header">
          <div class="header-info">
            <div class="header-icon-badge blue">
              <i class="ri-community-line"></i>
            </div>
            <div>
              <h3 id="heading-entities">Entidades Intervenientes</h3>
              <p class="section-subtitle">Dados cadastrais do Emissor e Adquirente homologados</p>
            </div>
          </div>
        </header>

        <div class="section-card-body">
          <div class="entities-grid">
            <!-- Emissor -->
            <div class="entity-subcard emissor-card">
              <div class="entity-tag-header">
                <span class="entity-role-badge primary"><i class="ri-shield-check-fill"></i> EMISSOR (FORNECEDOR)</span>
              </div>
              <div class="entity-content">
                <div class="entity-icon-col">
                  <div class="emissor-icon-badge">
                    <i class="ri-shield-star-line"></i>
                  </div>
                </div>
                <div class="entity-info-col">
                  <h4 class="entity-name">SecurPro Angola Segurança, Lda.</h4>
                  <div class="entity-meta-list">
                    <span class="meta-row"><i class="ri-barcode-line"></i> NIF: <strong>5403079050</strong></span>
                    <span class="meta-row"><i class="ri-government-line"></i> Licença MinInt: <strong>nº 088/2019</strong></span>
                    <span class="meta-row"><i class="ri-map-pin-line"></i> Luanda Trade Center, 7º Andar · Luanda, Angola</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Adquirente -->
            <div class="entity-subcard adquirente-card">
              <div class="entity-tag-header">
                <span class="entity-role-badge client"><i class="ri-user-star-line"></i> ADQUIRENTE (CLIENTE)</span>
              </div>
              <div class="entity-content">
                <div class="entity-icon-col">
                  @if (cliente()?.url || cliente()?.logoUrl) {
                  <img [src]="cliente()?.url || cliente()?.logoUrl" alt="Logo Cliente" class="client-mini-logo" />
                  } @else {
                  <div class="client-mini-avatar">
                    <i class="ri-building-line"></i>
                  </div>
                  }
                </div>
                <div class="entity-info-col">
                  <h4 class="entity-name">{{ cliente()?.nome || documento()?.cliente?.nome || ('Cliente #' + documento()?.idCliente) }}</h4>
                  <div class="entity-meta-list">
                    <span class="meta-row"><i class="ri-barcode-line"></i> NIF: <strong>{{ cliente()?.nif || documento()?.cliente?.nif || 'Consumidor Final' }}</strong></span>
                    @if (cliente()?.numTelefone || documento()?.cliente?.numTelefone) {
                    <span class="meta-row"><i class="ri-phone-line"></i> Tel: <strong>{{ cliente()?.numTelefone || documento()?.cliente?.numTelefone }}</strong></span>
                    }
                    <span class="meta-row"><i class="ri-map-pin-line"></i> {{ cliente()?.endereco || documento()?.cliente?.endereco || 'Luanda, Angola' }}</span>
                    @if (cliente()?.email || documento()?.cliente?.email) {
                    <span class="meta-row"><i class="ri-mail-line"></i> {{ cliente()?.email || documento()?.cliente?.email }}</span>
                    }
                    @if (cliente()?.nomeResponsavel) {
                    <span class="meta-row"><i class="ri-user-follow-line"></i> Responsável: <strong>{{ cliente()?.nomeResponsavel }}</strong></span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Tabela de Itens e Serviços -->
      <section class="section-card items-section-card" aria-labelledby="heading-items">
        <header class="section-card-header">
          <div class="header-info">
            <div class="header-icon-badge blue">
              <i class="ri-file-list-3-line"></i>
            </div>
            <div>
              <h3 id="heading-items">Serviços e Artigos Faturados</h3>
              <p class="section-subtitle">Linhas discriminadas com taxas de incidência de imposto</p>
            </div>
          </div>
          <span class="count-pill">{{ documento()?.lines?.length || 0 }} item(ns)</span>
        </header>

        <div class="section-card-body p-0">
          <div class="table-responsive">
            <table class="detail-items-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Descrição do Serviço</th>
                  <th class="text-center">Qtd</th>
                  <th class="text-right">Preço Unit.</th>
                  <th class="text-center">Taxa IVA</th>
                  <th class="text-right">Total Líquido</th>
                </tr>
              </thead>
              <tbody>
                @for (l of documento()?.lines || []; track l.lineNumber || $index; let idx = $index) {
                <tr>
                  <td class="col-idx">{{ idx + 1 }}</td>
                  <td>
                    <strong>{{ l.productDescription || 'Serviço de Segurança' }}</strong>
                    @if (l.productCode) {
                    <small class="muted-block">Ref: {{ l.productCode }} · Unidade: {{ l.unitOfMeasure || 'un' }}</small>
                    }
                  </td>
                  <td class="text-center font-mono">{{ l.quantity }}</td>
                  <td class="text-right font-mono">{{ formatCurrency(l.unitPrice) }}</td>
                  <td class="text-center">
                    @if (l.taxes && l.taxes.length > 0) {
                    <span class="tax-tag">{{ l.taxes[0].taxCode }} ({{ l.taxes[0].taxPercentage }}%)</span>
                    } @else {
                    <span class="tax-tag">NOR (14%)</span>
                    }
                  </td>
                  <td class="text-right font-mono font-bold">{{ formatCurrency(l.creditAmount || (l.quantity *
                    l.unitPrice)) }}</td>
                </tr>
                } @empty {
                <tr>
                  <td colspan="6" class="text-center py-4 muted">Sem linhas registadas no documento.</td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>

    <!-- Coluna Direita: Totais e Coordenadas -->
    <aside class="content-sidebar">
      <!-- Card de Totais Fiscais -->
      <section class="section-card totals-summary-card" aria-labelledby="heading-totals">
        <header class="section-card-header">
          <div class="header-info">
            <div class="header-icon-badge amber">
              <i class="ri-calculator-line"></i>
            </div>
            <div>
              <h4 id="heading-totals">Resumo Fiscal do Documento</h4>
              <p class="section-subtitle">Valores apurados em Kwanzas (Kz)</p>
            </div>
          </div>
        </header>

        <div class="section-card-body">
          <div class="totals-breakdown">
            <div class="tot-row">
              <span class="tot-lbl">Subtotal Ilíquido (Net Total):</span>
              <strong class="font-mono">{{ formatCurrency(documento()?.netTotal) }}</strong>
            </div>
            <div class="tot-row">
              <span class="tot-lbl">IVA Apurado (Tax Payable):</span>
              <strong class="font-mono text-success">+ {{ formatCurrency(documento()?.taxPayable) }}</strong>
            </div>
            <div class="tot-grand-box">
              <div class="grand-header">
                <span class="grand-lbl">Total a Liquidar (Gross Total):</span>
                <span class="badge-fiscal">Homologado AGT</span>
              </div>
              <strong class="font-mono grand-value">{{ formatCurrency(documento()?.grossTotal) }}</strong>
            </div>
          </div>
        </div>
      </section>
    </aside>
  </div>
  }

  <!-- CONTEÚDO DA ABA 2: PAGAMENTO & RECIBOS -->
  @if (activeTab() === 'pagamento') {
  <div class="tab-content-grid">
    <div class="content-main">
      <!-- 1. Estado da Liquidação & Saldo -->
      <section class="section-card balance-status-card" aria-labelledby="heading-balance">
        <header class="section-card-header">
          <div class="header-info">
            <div class="header-icon-badge blue">
              <i class="ri-wallet-3-line"></i>
            </div>
            <div>
              <h3 id="heading-balance">Estado da Liquidação & Saldo</h3>
              <p class="section-subtitle">Posição financeira e liquidação fiscal do documento</p>
            </div>
          </div>
          <div class="header-extra">
            <span class="pay-status-pill" [class.paid]="isPaga()" [class.unpaid]="!isPaga()">
              <span class="dot"></span>
              {{ isPaga() ? 'Liquidada · 100%' : (documento()?.paymentStatus || 'Em Aberto') }}
            </span>
            @if (isAceite() && !isPaga()) {
            <button type="button" class="btn-primary-pay" (click)="abrirModalSimular()">
              <i class="ri-hand-coin-line"></i> Registar Liquidação
            </button>
            }
          </div>
        </header>

        <div class="section-card-body">
          <div class="kpi-stat-grid">
            <!-- Valor Total -->
            <div class="kpi-stat-box neutral">
              <div class="stat-top">
                <span class="stat-lbl">Valor Total Faturado</span>
                <i class="ri-money-dollar-circle-line stat-ico"></i>
              </div>
              <strong class="stat-val font-mono">{{ formatCurrency(documento()?.grossTotal) }}</strong>
              <span class="stat-hint">Valor fiscal com impostos</span>
            </div>

            <!-- Valor Liquidado -->
            <div class="kpi-stat-box success">
              <div class="stat-top">
                <span class="stat-lbl">Valor Já Liquidado</span>
                <i class="ri-checkbox-circle-line stat-ico"></i>
              </div>
              <strong class="stat-val font-mono text-success">{{ formatCurrency(saldo()?.valorPago || (isPaga() ? documento()?.grossTotal : 0)) }}</strong>
              <span class="stat-hint">Recibos emitidos pela AGT</span>
            </div>

            <!-- Saldo em Aberto -->
            <div class="kpi-stat-box danger" [class.resolved]="isPaga()">
              <div class="stat-top">
                <span class="stat-lbl">Saldo em Aberto</span>
                <i class="ri-time-line stat-ico"></i>
              </div>
              <strong class="stat-val font-mono" [class.text-danger]="!isPaga()" [class.text-success]="isPaga()">
                {{ formatCurrency(saldo()?.saldoEmDivida || (isPaga() ? 0 : documento()?.grossTotal)) }}
              </strong>
              <span class="stat-hint">{{ isPaga() ? 'Totalmente quitado' : 'Montante pendente de pagamento' }}</span>
            </div>
          </div>
        </div>
      </section>

      <!-- 2. Secção de Recibos Emitidos (RC) -->
      <section class="section-card recibos-card" aria-labelledby="heading-recibos">
        <header class="section-card-header">
          <div class="header-info">
            <div class="header-icon-badge green">
              <i class="ri-file-shield-2-line"></i>
            </div>
            <div>
              <h3 id="heading-recibos">Recibos Fiscais de Pagamento (RC)</h3>
              <p class="section-subtitle">Emitidos e chancelados automaticamente pela AGT na liquidação</p>
            </div>
          </div>
          <span class="count-pill">{{ recibos().length }} recibo(s)</span>
        </header>

        <div class="section-card-body">
          @if (recibos().length > 0) {
          <div class="recibos-list">
            @for (rc of recibos(); track rc.id) {
            <div class="recibo-row">
              <div class="rc-icon"><i class="ri-receipt-line"></i></div>
              <div class="rc-meta">
                <strong>{{ rc.documentNo }}</strong>
                <small>Emitido em: {{ rc.documentDate | date: 'dd/MM/yyyy HH:mm' }}</small>
              </div>
              <div class="rc-amount font-mono">
                {{ formatCurrency(rc.valorPago) }}
              </div>
              <div class="rc-action">
                <button type="button" class="btn-rc-pdf" title="Descarregar Recibo Fiscal A4"
                  (click)="descarregarPdfRecibo(rc.id, rc.documentNo)">
                  <i class="ri-file-pdf-line"></i> Ver Recibo (A4)
                </button>
              </div>
            </div>
            }
          </div>
          } @else {
          <div class="empty-rc-box">
            <div class="empty-rc-icon-badge">
              <i class="ri-receipt-2-line"></i>
            </div>
            <h4>Nenhum recibo fiscal emitido até ao momento</h4>
            <p>Os recibos oficiais (série RC) são gerados no momento da validação do pagamento na AGT.</p>
            @if (isAceite() && !isPaga()) {
            <button type="button" class="btn-empty-pay" (click)="abrirModalSimular()">
              <i class="ri-hand-coin-line"></i> Registar Liquidação para Emitir Recibo
            </button>
            }
          </div>
          }
        </div>
      </section>
    </div>

    <!-- Coluna Direita: Canais de Pagamento Separados em Cartões Distintos -->
    <aside class="content-sidebar payment-sidebar">
      <!-- Canal 1: Multicaixa Express / ATM -->
      <section class="section-card channel-card mcx-channel" aria-labelledby="heading-mcx">
        <header class="section-card-header">
          <div class="header-info">
            <div class="header-icon-badge purple">
              <i class="ri-qr-code-line"></i>
            </div>
            <div>
              <h4 id="heading-mcx">Multicaixa Express / ATM</h4>
              <p class="section-subtitle">Pagamento por referência bancária</p>
            </div>
          </div>
        </header>

        <div class="section-card-body">
          @if (documento()?.paymentReference) {
          <div class="mcx-voucher">
            <div class="voucher-field">
              <span class="v-lbl">Entidade</span>
              <strong class="v-val font-mono">00123</strong>
            </div>
            <div class="voucher-field highlight">
              <span class="v-lbl">Referência</span>
              <div class="ref-copy-wrapper">
                <strong class="font-mono ref-number">{{ documento()?.paymentReference }}</strong>
                <button type="button" class="btn-copy-ref" title="Copiar Referência"
                  (click)="copiarTexto(documento()?.paymentReference, 'Referência Multicaixa')">
                  <i class="ri-file-copy-line"></i>
                </button>
              </div>
            </div>
            <div class="voucher-field">
              <span class="v-lbl">Montante</span>
              <strong class="v-val font-mono text-primary">{{ formatCurrency(documento()?.grossTotal) }}</strong>
            </div>
          </div>
          } @else {
          <div class="channel-empty-box">
            <i class="ri-bank-card-line empty-ico"></i>
            <span class="empty-title">Referência ainda não gerada</span>
            <p class="empty-desc">Gere uma referência para permitir o pagamento via App Multicaixa Express ou Caixas ATM.</p>
            @if (isAceite()) {
            <button type="button" class="btn-generate-mcx" [disabled]="actionLoading()"
              (click)="gerarReferenciaMulticaixa()">
              <i class="ri-qr-code-line"></i> Gerar Referência Multicaixa
            </button>
            }
          </div>
          }
        </div>
      </section>

      <!-- Canal 2: Transferência Bancária -->
      <section class="section-card channel-card bank-channel" aria-labelledby="heading-banks">
        <header class="section-card-header">
          <div class="header-info">
            <div class="header-icon-badge blue">
              <i class="ri-bank-line"></i>
            </div>
            <div>
              <h4 id="heading-banks">Transferência Bancária</h4>
              <p class="section-subtitle">Coordenadas oficiais SecurPro</p>
            </div>
          </div>
        </header>

        <div class="section-card-body">
          <div class="bank-accounts-stack">
            <!-- Conta BAI -->
            <div class="bank-card-item">
              <div class="bank-item-header">
                <div class="bank-name">
                  <span class="bank-pill">BAI</span>
                  <strong>Banco Angolano de Investimentos</strong>
                </div>
                <button type="button" class="btn-copy-iban" title="Copiar IBAN BAI"
                  (click)="copiarTexto('AO06.0040.0000.4773.8518.1018.8', 'IBAN BAI')">
                  <i class="ri-file-copy-line"></i> Copiar
                </button>
              </div>
              <div class="bank-iban font-mono">
                AO06.0040.0000.4773.8518.1018.8
              </div>
            </div>

            <!-- Conta BIC -->
            <div class="bank-card-item">
              <div class="bank-item-header">
                <div class="bank-name">
                  <span class="bank-pill alt">BIC</span>
                  <strong>Banco BIC Angola</strong>
                </div>
                <button type="button" class="btn-copy-iban" title="Copiar IBAN BIC"
                  (click)="copiarTexto('AO06.0051.0000.2170.0811.1017.9', 'IBAN BIC')">
                  <i class="ri-file-copy-line"></i> Copiar
                </button>
              </div>
              <div class="bank-iban font-mono">
                AO06.0051.0000.2170.0811.1017.9
              </div>
            </div>
          </div>

          <div class="beneficiary-note">
            <i class="ri-shield-check-line"></i>
            <span><strong>Beneficiário:</strong> SecurPro Angola Segurança, Lda. · NIF: 5403079050</span>
          </div>
        </div>
      </section>
    </aside>
  </div>
  }

  <!-- CONTEÚDO DA ABA 3: AUDITORIA FISCAL AGT -->
  @if (activeTab() === 'auditoria') {
  <div class="auditoria-container">
    <section class="section-card auditoria-card" aria-labelledby="heading-audit">
      <header class="section-card-header">
        <div class="header-info">
          <div class="header-icon-badge purple">
            <i class="ri-shield-keyhole-line"></i>
          </div>
          <div>
            <h3 id="heading-audit">Trilho de Auditoria Fiscal AGT</h3>
            <p class="section-subtitle">Registo criptográfico das transmissões de lote fiscal conforme o Decreto Presidencial 292/18</p>
          </div>
        </div>
        <span class="badge-audit-cert font-mono"><i class="ri-lock-line"></i> Certificado nº 042/AGT/2024</span>
      </header>

      <div class="section-card-body">
        <div class="audit-timeline">
          <!-- Evento 1: Geração e Assinatura -->
          <div class="timeline-step completed">
            <div class="t-marker"><i class="ri-check-line"></i></div>
            <div class="t-body">
              <div class="t-header">
                <strong>1. Fatura Gerada & Assinada Criptograficamente</strong>
                <span class="t-status ok">CONCLUÍDO</span>
              </div>
              <p>Documento gerado com assinatura digital RSA 2048 SHA-256 via módulo HSM local certificado.</p>
              <div class="t-meta font-mono font-xs">
                Certificado de Software: nº 042/AGT/2024 · SecurPro ERP Core v4.1
              </div>
            </div>
          </div>

          <!-- Evento 2: Transmissão Lote AGT -->
          <div class="timeline-step" [class.completed]="!isGuardada()">
            <div class="t-marker">
              @if (isGuardada()) { <i class="ri-time-line"></i> } @else { <i class="ri-check-line"></i> }
            </div>
            <div class="t-body">
              <div class="t-header">
                <strong>2. Transmissão do Lote Fiscal para Servidor AGT</strong>
                <span class="t-status" [class.ok]="!isGuardada()" [class.pending]="isGuardada()">
                  {{ isGuardada() ? 'AGUARDANDO ENVIO' : 'TRANSMITIDO' }}
                </span>
              </div>
              <p>Envio de pacote estruturado XML para o endpoint central da AGT (https://agt.minfin.gov.ao/ws).</p>
              @if (documento()?.requestId) {
              <div class="t-meta font-mono font-xs text-primary">
                Identificador do Pedido (RequestId): <strong>{{ documento()?.requestId }}</strong>
              </div>
              }
            </div>
          </div>

          <!-- Evento 3: Validação Fiscal AGT -->
          <div class="timeline-step" [class.completed]="isAceite() || isPaga()" [class.failed]="isRejeitada()">
            <div class="t-marker">
              @if (isAceite() || isPaga()) { <i class="ri-check-line"></i> }
              @else if (isRejeitada()) { <i class="ri-close-line"></i> }
              @else { <i class="ri-time-line"></i> }
            </div>
            <div class="t-body">
              <div class="t-header">
                <strong>3. Resposta de Homologação da AGT</strong>
                <span class="t-status" [class.ok]="isAceite() || isPaga()" [class.danger]="isRejeitada()"
                  [class.pending]="isSubmetida() || isGuardada()">
                  {{ isAceite() || isPaga() ? 'HOMOLOGADA' : (isRejeitada() ? 'REJEITADA' : 'EM PROCESSAMENTO') }}
                </span>
              </div>
              @if (isAceite() || isPaga()) {
              <p>Documento aprovado e chancelado pela AGT. Selo digital validado com sucesso.</p>
              } @else if (isRejeitada()) {
              <p class="text-danger">Documento rejeitado pela AGT. É obrigatória a criação de uma fatura de retificação.
              </p>
              } @else {
              <p>Aguardando validação de sintaxe e regras de negócio da AGT.</p>
              }
            </div>
          </div>

          <!-- Evento 4: Quitação Fiscal e Emissão de Recibo -->
          <div class="timeline-step" [class.completed]="isPaga()">
            <div class="t-marker">
              @if (isPaga()) { <i class="ri-check-line"></i> } @else { <i class="ri-time-line"></i> }
            </div>
            <div class="t-body">
              <div class="t-header">
                <strong>4. Quitação Fiscal & Recibo (RC)</strong>
                <span class="t-status" [class.ok]="isPaga()" [class.pending]="!isPaga()">
                  {{ isPaga() ? 'PAGO & RECONCILIADO' : 'AGUARDA PAGAMENTO' }}
                </span>
              </div>
              <p>Após quitação bancária, é emitido o Recibo Fiscal (RC) oficial com numeração sequencial da série RC da
                AGT.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  }
  }
</div>

<!-- Modal para Simular / Liquidar Pagamento -->
<p-dialog [(visible)]="modalSimularVisible" [modal]="true" [header]="'Registar Liquidação / Pagamento'"
  [style]="{ width: '480px', maxWidth: '95vw' }">
  <div class="simular-modal-body">
    <div class="modal-notice">
      <i class="ri-information-line"></i>
      <span>Este processo valida a quitação e gera automaticamente o Recibo Fiscal (RC) oficial chancelado na
        AGT.</span>
    </div>

    <div class="form-group my-3">
      <label class="font-bold block mb-1">Montante a Liquidar (Kz) <span class="text-danger">*</span></label>
      <p-inputnumber [(ngModel)]="simularValor" mode="currency" currency="AOA" locale="pt-AO" [min]="0.01"
        class="w-full" />
      <small class="muted-text block mt-1">Saldo em dívida restante: {{ formatCurrency(saldo()?.saldoEmDivida ??
        documento()?.grossTotal) }}</small>
    </div>
  </div>

  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <button type="button" class="btn-cancel" (click)="modalSimularVisible = false">Cancelar</button>
      <button type="button" class="btn-primary" [disabled]="simulandoPagamento" (click)="executarSimularPagamento()">
        <i class="ri-check-line" [class.ri-loader-4-line]="simulandoPagamento"
          [class.animate-spin]="simulandoPagamento"></i>
        {{ simulandoPagamento ? 'A processar...' : 'Confirmar Pagamento' }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<!-- Modal de Confirmação de Ações Irreversíveis -->
<p-dialog [(visible)]="modalConfirmarAcao" [modal]="true" [header]="acaoPendente?.titulo || 'Confirmação'"
  [style]="{ width: '450px', maxWidth: '95vw' }">
  <p class="py-2 text-base text-gray-200">{{ acaoPendente?.mensagem }}</p>
  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <button type="button" class="btn-cancel" (click)="cancelarAcao()">Cancelar</button>
      <button type="button" class="btn-confirm-action" (click)="confirmarAcao()">Confirmar</button>
    </div>
  </ng-template>
</p-dialog>